import type {
  SubmitAnswerBody,
  SubmitAnswerResponse,
  GetExaminationResponse,
  StartExaminationResponse,
} from 'src/types/examination';

import axiosInstance, { endpoints } from 'src/lib/axios';

import {
  SubmitAnswerBodySchema,
  SubmitAnswerResponseSchema,
  GetExaminationResponseSchema,
  StartExaminationResponseSchema,
} from 'src/types/examination';

export async function getExaminationById(examinationId: number): Promise<GetExaminationResponse> {
  const response = await axiosInstance.get(endpoints.examination.details(examinationId));

  try {
    return GetExaminationResponseSchema.parse(response.data);
  } catch (error) {
    console.error('Schema validation failed:', error);
    console.error('Raw response data:', response.data);
    throw error;
  }
}

export async function startExamination(
  examinationId: number,
  accessCode?: string
): Promise<StartExaminationResponse> {
  const response = await axiosInstance.post(
    endpoints.examination.start(examinationId),
    accessCode ? { accessCode } : undefined
  );

  return StartExaminationResponseSchema.parse(response.data);
}

export async function submitAnswer(data: SubmitAnswerBody): Promise<SubmitAnswerResponse> {
  const validatedData = SubmitAnswerBodySchema.parse(data);

  const response = await axiosInstance.post(
    endpoints.examination.submitAnswer(validatedData.attemptId),
    {
      questionId: validatedData.questionId,
      answerIds: validatedData.answerIds,
    }
  );

  try {
    return SubmitAnswerResponseSchema.parse(response.data);
  } catch (error) {
    console.error('Submit answer schema validation failed:', error);
    console.error('Raw response data:', response.data);
    console.error('Expected schema vs actual keys:', {
      expectedKeys: ['success', 'message', 'data'],
      actualKeys: Object.keys(response.data),
      dataKeys: response.data.data ? Object.keys(response.data.data) : 'data is undefined',
    });
    throw error;
  }
}

export async function skipQuestion(
  attemptId: number,
  questionId: number
): Promise<SubmitAnswerResponse> {
  const data = { attemptId, questionId, answerIds: [] };
  const validatedData = SubmitAnswerBodySchema.parse(data);

  const response = await axiosInstance.post(
    endpoints.examination.submitAnswer(validatedData.attemptId),
    {
      questionId: validatedData.questionId,
      answerIds: validatedData.answerIds,
    }
  );

  return SubmitAnswerResponseSchema.parse(response.data);
}

export async function abortExamination(attemptId: number): Promise<void> {
  await axiosInstance.post(endpoints.examination.abort(attemptId));
}
